<template>
  <dc-layout-main>
    <dc-layout-content>
      <dc-layout-content>
        <cos-table
          serial
          rowKey="clientId"
          :columns="columns"
          v-model:search="queryForm"
          @fetch="getList"
          @mask="showMask"
          ref="tableRef"
          tableId="DcCosOFbuNewClientEvaluation"
        >
          <template #search>
            <a-form :model="queryForm">
              <dc-form-item :label="t('clue.审核状态')">
                <CosSelect
                  v-model:value="queryForm.auditStatus"
                  :options="oaReviewStatus"
                  :placeholder="t('common.pleaseSelect')"
                  allowClear
                  show-arrow
                />
<!--                <a-radio-group v-model:value="queryForm.auditStatus" @change="handleQueryChange('search')">-->
<!--                  <a-radio-button v-for="item in oaReviewStatus" :key="item.value" :value="item.value">{{-->
<!--                      t(item.lang)-->
<!--                    }}</a-radio-button>-->
<!--                </a-radio-group>-->
              </dc-form-item>
              <dc-form-item :label="t('clue.customerName')">
                <a-input
                  v-model:value="queryForm.customerName"
                  allowClear
                  :placeholder="t('common.pleaseInput')"
                />
              </dc-form-item>
              <dc-form-item :label="t('clue.followerName')">
                <UserSelect v-model:value="queryForm.seller" :placeholder="t('common.pleaseSelect')" allowClear/>
              </dc-form-item>
              <dc-form-item :label="t('clue.申请单号')">
                <a-input
                  v-model:value="queryForm.applyNo"
                  allowClear
                  :placeholder="t('common.pleaseInput')"
                />
              </dc-form-item>
              <dc-form-item :label="t('clue.流程创建人')">
                <UserSelect v-model:value="queryForm.applicant" :placeholder="t('common.pleaseSelect')" allowClear/>
              </dc-form-item>
              <dc-form-item :label="t('clue.流程创建时间')">
                <CosRangePicker
                  isOutputBeijingTime
                  v-model:startTime="queryForm.startCreateTime"
                  v-model:endTime="queryForm.endCreateTime"
                />
              </dc-form-item>
              <dc-form-item :label="t('clue.客户创建时间')">
                <CosRangePicker
                  isOutputBeijingTime
                  v-model:startTime="queryForm.startCustomerCreateTime"
                  v-model:endTime="queryForm.endCustomerCreateTime"
                />
              </dc-form-item>
            </a-form>
          </template>

          <template #bodyCell="{ column, record, text }">
            <template v-if="column.dataIndex === 'customerName'">
              <div class="flex">
                <router-link
                  class="ant-table-cell-ellipsis"
                  :to="`/ofbu/newClientEvaluation/view?newClientId=${record.id}`"
                  :title="text"
                >{{ text || '--' }}</router-link
                >
              </div>
            </template>
            <template v-if="column.dataIndex === 'auditStatus'">
              <dc-status :enums="statusEnum" :value="text" />
            </template>
            <template v-if="column.dataIndex === 'nextReviewer'">
              <p>{{ (record.nextReviewer&&record.nextReviewer.length>0)? record.nextReviewer.map(item => item.employeeName||'--').join('、'): '--' }}</p>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <MoreButton>
                <!-- 仅草稿状态可以提交 -->
                <SellerButton
                  v-permission="'ofbu_new_client_evaluation_draft_edit_btn'"
                  type="link"
                  @click="handleNewClientEvaluationDraftEdit(record)"
                  :disabled="record.auditStatus !== '10'"
                >{{ t('btn.edit') }}</SellerButton
                >
                <!-- 仅已驳回状态可以提交 -->
                <SellerButton
                  v-permission="'ofbu_new_client_evaluation_submit_review_btn'"
                  type="link"
                  @click="handleNewClientEvaluationSubmitReview(record)"
                  :disabled="record.auditStatus !== '11'"
                >{{ t('btn.提交') }}</SellerButton
                >
                <!-- 仅审核中流程可以撤回 -->
                <SellerButton
                  v-permission="'ofbu_new_client_evaluation_recall_btn'"
                  :disabled="record.auditStatus !== '20'"
                  type="link"
                  @click="handleNewClientEvaluationRecall(record)"
                >{{ t('btn.withdraw') }}</SellerButton
                >
                <!-- 审核中的流程不能删除 -->
                <SellerButton
                  v-permission="'ofbu_new_client_evaluation_del_btn'"
                  type="link"
                  :disabled="record.auditStatus === '20'"
                  @click="handleNewClientEvaluationDelete(record)"
                >{{ t('btn.del') }}</SellerButton
                >
<!--                <SellerButton-->
<!--                  v-permission="'ofbu_clue_invalid_btn'"-->
<!--                  type="link"-->
<!--                  :workCode="record.follower"-->
<!--                  :disabled="record.clueStatus === 8"-->
<!--                  @click="handleBecomeInvalid(record)"-->
<!--                >{{ t('btn.invalidate') }}</SellerButton-->
<!--                >-->
              </MoreButton>
            </template>
          </template>
        </cos-table>
      </dc-layout-content>
    </dc-layout-content>

  </dc-layout-main>
</template>
<script setup lang="ts">

import { computed, reactive, ref } from 'vue'
import { NewClientEvaluationItem, NewClientEvaluationParams } from '@/typings/api/clueManage'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { cloneDeep } from 'lodash-es'
import {
  newClientEvaluationDelete,
  newClientEvaluationList, newClientEvaluationRetract
} from '@/api/overseasSales/newClientEvaluation'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import Modal from '@/hooks/modalType'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'
const { t } = useI18n()
const router = useRouter()
const getList = (queryForm: NewClientEvaluationParams, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  newClientEvaluationList(params).then((res) => {
    callBack(res)
  })
}
// 新客评审提审（和编辑一个道理）
const handleNewClientEvaluationSubmitReview = (row?: NewClientEvaluationItem) => {
  if (!row) return
  router.push({ path: '/ofbu/newClientEvaluation/edit', query: { newClientId: row.id, review: '1' } })
}
// 草稿编辑
const handleNewClientEvaluationDraftEdit = (row?: NewClientEvaluationItem) => {
  if (!row) return
  router.push({ path: '/ofbu/newClientEvaluation/edit', query: { draftId: row.id } })
}
// 新客评审删除
const handleNewClientEvaluationDelete = (row?: NewClientEvaluationItem) => {
  if (!row) return
  Modal.delete({
    content: t('tips.OADelete'),
    onOk() {
      newClientEvaluationDelete({ id: row.id }).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value?.delFetch()
      })
    }
  })
}
// 新客评审撤回
const handleNewClientEvaluationRecall = (row?: NewClientEvaluationItem) => {
  if (!row) return
  DcConfirm.warning({
    cancelText: t('btn.cancel'),
    content: t('tips.OARevoke'),
    okText: t('btn.sure'),
    onOk() {
      newClientEvaluationRetract({ id: row.id }).then(() => {
        message.success(t('tips.revokeSuccess'))
        tableRef.value?.search()
      })
    }
  })
}
// 获取详情联系人信息
const showMask = (record: NewClientEvaluationItem, callBack: (res: any) => void) => {
  if (!record.newClientId) {
    return
  }
  salesClueDetail({ clueId: record.newClientId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const tableRef = ref()
const queryForm = reactive<NewClientEvaluationParams>({ auditStatus: '20', applyType: 1 })
const statusEnum = computed(() =>
  oaReviewStatus.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
)
const columns = computed(() => [
  {
    title: t('clue.customerName'),
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: t('clue.客户创建时间'), dataIndex: 'customerCreateTime', width: 190 },
  { title: t('clue.followerName'), dataIndex: 'sellerName' },
  { title: t('clue.申请单号'), dataIndex: 'applyNo' },
  { title: t('clue.流程创建人'), dataIndex: 'applicantName' },
  { title: t('clue.流程创建时间'), dataIndex: 'applyTime', width: 190 },
  { title: t('clue.当前审核人'), dataIndex: 'nextReviewer' },
  { title: t('clue.审核状态'), dataIndex: 'auditStatus' },
  { title: t('clue.当前审核意见'), dataIndex: 'reviewComments' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 260,
      en: 280
    },
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosOFbuNewClientEvaluationPage' }
</script>
<style scoped lang="scss">

</style>
